<template>
    <div class="sbsProject">
        <div class="sbsProject__filters">
            <div class="sbsProject__filter">
                <q-input v-model="filters.search" @update:model-value="(value) => onFiltersChange('search', value)"
                    outlined dense placeholder="Поиск по названию" clearable debounce="500">
                    <template v-slot:prepend>
                        <q-icon name="search" />
                    </template>
                </q-input>
            </div>
            <div class="sbsProject__filter">
                <q-input v-model="filters.guid_search"
                    @update:model-value="(value) => onFiltersChange('guid_search', value)" outlined dense
                    placeholder="Поиск по guid" clearable debounce="500">
                    <template v-slot:prepend>
                        <q-icon name="search" />
                    </template>
                </q-input>
            </div>
        </div>
        <CustomTable title="Сводная по СБС проектам" :rowsData="this.rowsData" :columns="sbsProjectTableColumns"
            :stickyHeader="true" :loading="isFetching" :custom-body="true" :small="true" :height="300"
            :showPagination="true" :pagesNumber="pagesNumber" :count="totalRecords"
            :onPaginationChange="handlePaginationChange">
            <template #top-right>
                <slot name="top-right">
                    <q-btn :loading="isFetching" @click="refetch" color="primary" size="sm">
                        <q-icon name="replay" />
                    </q-btn>
                </slot>
            </template>

            <template #customBody="props">
                <q-tr>
                    <custom-table-cell align="center" vertical-align="center" width="130px">
                        {{ props.row.sbs_project_id }}
                    </custom-table-cell>

                    <custom-table-cell align="left" vertical-align="center">
                        <span>{{ props.row.naimenovanie }}</span>
                        <br>
                        <span style="font-size: 10px;">
                            Базовое наименование: {{ props.row.bazovoe_naimenovanie }}
                        </span>
                    </custom-table-cell>

                    <custom-table-cell align="left" vertical-align="center">
                        {{ props.row.inagro_vid_proekta__view }}
                    </custom-table-cell>

                    <custom-table-cell align="left" vertical-align="center">
                        {{ props.row.klass__view }}
                    </custom-table-cell>

                    <custom-table-cell align="left" vertical-align="center" style="font-size: 11px;">
                        {{ props.row.key__ssylka }}
                    </custom-table-cell>

                    <custom-table-cell align="left" vertical-align="center" style="font-size: 11px;">
                        {{ props.row.ssylka__id }}
                    </custom-table-cell>

                    <custom-table-cell align="center" vertical-align="center">
                        {{ formatDate(props.row.planovaya_data_nachala) }}
                    </custom-table-cell>

                    <custom-table-cell align="center" vertical-align="center">
                        {{ formatDate(props.row.planovaya_data_okonchaniya) }}
                    </custom-table-cell>

                    <custom-table-cell align="center" vertical-align="center">
                        {{ formatDate(props.row.date_modified, true) }}
                    </custom-table-cell>

                    <custom-table-cell align="center" vertical-align="center">
                        {{ formatDate(props.row.updated_at, true) }}
                    </custom-table-cell>
                </q-tr>
            </template>
        </CustomTable>
    </div>
</template>

<script>
import CustomTable from "@/components/common/CustomTable";
import CustomTableCell from "@/components/common/CustomTable/custom-table-cell";
import {
    getSbsProjectList,
    sbsProjectTableColumns,
} from "@/views/sbsProject/services";
import { formatDate } from "@/utils/formatDate";

export default {
    name: "SbsProject",
    components: { CustomTableCell, CustomTable },
    data() {
        return {
            sbsProjectTableColumns,
            rowsData: [],
            totalRecords: 0,
            isFetching: false,
            pagination: {
                page: 1,
                limit: 30,
            },
            filters: {
                search: '',
                guid_search: ''
            },
        }
    },
    methods: {
        formatDate,
        async getData() {
            this.isFetching = true
            const queryParams = {
                ...this.filters,
                page: this.pagination.page,
                limit: this.pagination.limit,
            }
            const res = await getSbsProjectList(queryParams)
            if (!res) return;
            this.isFetching = false
            this.rowsData = res?.data || []
            this.totalRecords = res?.total || 0
        },
        handlePaginationChange(newPage) {
            this.pagination.page = newPage;
            this.getData();
        },
        onFiltersChange(key, value) {
            this.filters[key] = value;
            this.pagination.page = 1;
            this.getData();
        },
        refetch() {
            this.getData();
        },
    },
    computed: {
        pagesNumber() {
            return Math.ceil(this.totalRecords / this.pagination.limit);
        },
    },
    mounted() {
        this.getData()
    },
}
</script>

<style scoped lang="scss">
.sbsProject {
    height: calc(100vh - 120px);
    display: flex;
    flex-direction: column;
}

.sbsProject__filters {
    margin-bottom: 20px;
    display: flex;
    gap: 20px;
    align-items: flex-end;
    flex-shrink: 0;

    .sbsProject__filter {
        width: 250px;
    }
}
</style>